/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import dynamic from "next/dynamic";
import {isServerSideRendering} from "@/app/utils/common";
const CookiesPolicyModal = dynamic(() => import("@/app/components/CookiesPolicyModal"), {ssr: false});
const AccesiBe = dynamic(() => import("@/app/components/AccesiBe"), {ssr: false});
const Signifyd = dynamic(() => import("@/app/components/Signifyd"), {ssr: false});

export default function AfterMainContent () {
    if(!isServerSideRendering() && navigator && navigator.userAgent
        && !navigator.userAgent.includes('GTmetrix')
        && !navigator.userAgent.includes('PageSpeed')) {
        return <>
            <CookiesPolicyModal />
            <AccesiBe />
            <Signifyd />
        </>;
    }

    return <></>;
}